import { styled } from "@pigment-css/react";
import { useTranslations } from "@acto/web-common/locales";
import { CALENDAR_DAY_WIDTH } from "@acto/taskpane/field-sales-2/components/primitives/Calendar/constants";
import { TimeSelect } from "./TimeSelect";
import { TIME_SLOTS } from "./timeSlots";

// Matches the calendar band above: 7 day-cells + 6 column gaps (CalendarGrid uses the same
// spacing[12] gap).
const Row = styled("div")(({ theme }) => ({
  display: "flex",
  gap: theme.fieldSalesTwo.spacing[20],
  width: "100%",
  maxWidth: `calc(7 * ${CALENDAR_DAY_WIDTH}px + 6 * ${theme.fieldSalesTwo.spacing[12]})`,
  marginInline: "auto",
}));

interface TimeRangeProps {
  fromTime: string;
  toTime: string;
  onFromChange: (value: string) => void;
  onToChange: (value: string) => void;
}

export function TimeRange({ fromTime, toTime, onFromChange, onToChange }: TimeRangeProps) {
  const t = useTranslations("fieldSalesTwo.planMeeting");
  const endOptionsAfterFrom = TIME_SLOTS.filter((slot) => slot > fromTime);

  return (
    <Row>
      <TimeSelect label={t("from")} value={fromTime} options={TIME_SLOTS} onChange={onFromChange} />
      <TimeSelect
        label={t("to")}
        value={toTime}
        options={endOptionsAfterFrom}
        onChange={onToChange}
        min={fromTime}
        align="end"
      />
    </Row>
  );
}
